import { Container } from "@mantine/core";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** If true (default), pad enough at top to clear the fixed 64px nav so the
   *  page doesn't render under it. Pages that render a PageHero before the
   *  container should pass false — the hero already handles the nav area. */
  navOffset?: boolean;
}

const NAV_HEIGHT = 64;

/**
 * Standard content container. Top padding adapts to whether the route has
 * a PageHero in front of it (in which case the hero handles the nav clearance).
 */
export function PageContainer({ children, navOffset = true }: Props) {
  return (
    <Container
      size="xl"
      px={{ base: "md", md: "xl" }}
      pb="xl"
      style={{
        paddingTop: navOffset
          ? `calc(${NAV_HEIGHT}px + var(--mantine-spacing-xl))`
          : "var(--mantine-spacing-xl)",
      }}
    >
      {children}
    </Container>
  );
}
